var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.classes},[_vm._v(" "+_vm._s(_vm.letter[0])+" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showHint)?_c('span',{staticClass:"hint"},[_vm._v(" "+_vm._s(_vm.hintTxt)+" ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }